import Link from 'next/link';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

const PublicLayout: FunctionComponent<any> = ({ children }) => {
  return (
    <HomeContainer>
      <Link href="/">
        <Logo height="50px" src="/logo_transparent.png" />
      </Link>

      <div>{children}</div>
    </HomeContainer>
  );
};

export default PublicLayout;

const HomeContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 20vh;

  @media only screen and (max-width: 600px) {
    width: 80vw;
  }
`;

const Logo = styled.img`
  position: fixed;
  vertical-align: middle;
  top: 0px;
  left: 0px;
  height: 35px;
  margin: 20px;
  transition: transform 1s;

  :hover {
    transform: rotate(360deg);
  }

  @media only screen and (max-width: 600px) {
    margin: 10px;
  }
`;
